import { IconProps } from '.';

export const TagsIcon = ({ className, color = 'currentColor' }: IconProps) => {
  return (
    <svg
      width='22'
      height='19'
      viewBox='0 0 22 19'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <path
        d='M14.2588 4.28027V10.7197L8.02444 16.9541C6.91145 18.0671 5.10619 18.0671 3.99319 16.9541L1.58499 14.5459C0.471997 13.4329 0.471997 11.6276 1.58499 10.5146L7.81937 4.28027H14.2588Z'
        stroke={color}
        strokeWidth='1.5'
      />
      <g opacity='0.75'>
        <circle cx='10.5088' cy='8.03027' r='1.5' fill={color} />
      </g>
      <g opacity='0.75'>
        <circle cx='1.5' cy='1.5' r='1.5' transform='matrix(-1 0 0 1 12.0088 6.53027)' fill={color} />
      </g>
      <path
        opacity='0.5'
        d='M19.9629 9.98425C21.3688 11.3901 21.3688 13.6702 19.9629 15.076L17.5547 17.4843C16.1488 18.8901 13.8688 18.8901 12.4629 17.4843L11.5694 16.5907L16.5088 11.6512V6.53015L19.9629 9.98425Z'
        fill={color}
      />
      <path
        opacity='0.25'
        d='M20.0392 1.06055L13.5851 7.51465C12.9273 8.17247 12.1108 8.57429 11.2589 8.72266V7.18652C11.7223 7.06055 12.1607 6.8179 12.5245 6.4541L18.9786 0L20.0392 1.06055ZM5.47864 3.43945L5.09387 3.82422C4.85982 4.05828 4.6547 4.30431 4.47766 4.55957L0.978638 1.06055L2.03918 0L5.47864 3.43945Z'
        fill={color}
      />
    </svg>
  );
};
